import React from 'react'
import { Card } from 'react-bootstrap'
import { Shield, Sparkles } from 'lucide-react'
import { useQuery } from '@apollo/react-hooks'
import { clientsQueries } from '../../../graphql/queries'
import './HeroBanner.css'

const HeroBanner = ({ onContactDPO, onNewRequest }) => {
  const { data: dataMyName, loading: loadingMyName } = useQuery(clientsQueries.GET_MY_NAME)

  const userName = loadingMyName 
    ? '...' 
    : dataMyName?.me?.companyName || `${dataMyName?.me?.firstName || ''} ${dataMyName?.me?.lastName || ''}`.trim() || 'Usuário'

  const handleContactDPO = () => {
    const phoneNumber = '5511990213852'
    const message = encodeURIComponent('Olá, quero falar com DPO')
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`
    window.open(whatsappUrl, '_blank')
  }

  return (
    <Card className="hero-banner-card">
      <div className="hero-banner-badge">
        <Shield className="hero-banner-badge-icon" />
        <span>DATA PRIVACY</span>
      </div>
      <div className="hero-banner-content">
        <div className="hero-banner-main">
          <div className="hero-banner-text">
            <div className="hero-banner-subtitle">
              <Shield className="hero-banner-subtitle-icon" />
              <span>Central de Data Privacy & LGPD</span>
            </div>
            <h1 className="hero-banner-title">
              Olá, {userName}! 👋
            </h1>
            <p className="hero-banner-description">
              Gerencie documentos, histórico e projetos de privacidade de dados
            </p>
          </div>
          <div className="hero-banner-actions">
            <button className="hero-banner-btn-primary" onClick={handleContactDPO}>
              <Sparkles className="hero-banner-btn-icon" />
              Contatar DPO
            </button>
            <button className="hero-banner-btn-secondary" onClick={onNewRequest}>
              Nova solicitação
            </button>
          </div>
        </div>
      </div>
    </Card>
  )
}

export default HeroBanner
